import { roundDigits, gaussianRandom } from "../common/Helpers";

export const sectorSurfaceTypes = [
    'Asphalt', 
    'VeryLightCobbles', 
    'LightCobbles', 
    'MediumCobbles', 
    'RoughCobbles', 
    'VeryRoughCobbles'
];
export const sectorBonificationTypes = [
    {
        name: 'None'        
    },
    {
        name: 'MountainCat4',
        projectBlacklist: ['NationalChampionship', 'WorldChampionship']
    },
    {
        name: 'MountainCat3',
        projectBlacklist: ['NationalChampionship', 'WorldChampionship']
    },
    {
        name: 'MountainCat2',
        projectBlacklist: ['NationalChampionship', 'WorldChampionship']
    },
    {
        name: 'MountainCat1',
        projectBlacklist: ['NationalChampionship', 'WorldChampionship']
    },
    {
        name: 'MountainCatHC',
        projectBlacklist: ['NationalChampionship', 'WorldChampionship']
    },
    {
        name: 'MountainCat4B',
        projectWhitelist: ['GrandTour']
    },
    {
        name: 'MountainCat3B',
        projectWhitelist: ['GrandTour']
    },
    {
        name: 'MountainCat2B',
        projectWhitelist: ['GrandTour']
    },
    {
        name: 'MountainCat1B',
        projectWhitelist: ['GrandTour']
    },
    {
        name: 'MountainCatHCB',
        projectWhitelist: ['GrandTour']
    },
    {
        name: 'IntermediateSprint'
    },
    {
        name: 'IntermediateSprintB',
        projectWhitelist: ['GrandTour']
    },
    {
        name: 'MountainCatHCC',
        projectWhitelist: ['GrandTour']
    }
];


export function calculateSkill(raceEngine, sector, rider, ignoreForm = false) { 
    let energyModifier = raceEngine.modifiers.energy;
    let weightedSkillSum = 0;
    let totalWeights = 0;
    let riderFormBonus = ignoreForm ? 0 : formBonus(rider.form);
    if (sector.skillCalculation.climbing) {
    totalWeights += sector.skillCalculation.climbing;
    weightedSkillSum += sector.skillCalculation.climbing * (rider.climbing + riderFormBonus);
    }
    if (sector.skillCalculation.flat) {
    totalWeights += sector.skillCalculation.flat;
    weightedSkillSum += sector.skillCalculation.flat * (rider.flat + riderFormBonus);
    }
    if (sector.skillCalculation.downhill) {
    totalWeights += sector.skillCalculation.downhill;
    weightedSkillSum += sector.skillCalculation.downhill * (rider.downhill + riderFormBonus);
    }
    if (sector.skillCalculation.timeTrial) {
    totalWeights += sector.skillCalculation.timeTrial;
    weightedSkillSum += sector.skillCalculation.timeTrial * (rider.timeTrial + riderFormBonus);
    }
    if (sector.skillCalculation.cobbles) {
    totalWeights += sector.skillCalculation.cobbles;
    weightedSkillSum += sector.skillCalculation.cobbles * (rider.cobbles + riderFormBonus);
    }
    if (sector.skillCalculation.sprint) {
    totalWeights += sector.skillCalculation.sprint;
    weightedSkillSum += sector.skillCalculation.sprint * (rider.sprint + riderFormBonus);
    }
    let calculatedSkill = weightedSkillSum / totalWeights;      
    // energy factor
    calculatedSkill = calculatedSkill * Math.pow((energyModifier.baseFloor + rider.energy) / (energyModifier.baseFloor + energyModifier.base), energyModifier.power);

    return calculatedSkill;
}
  
export function calculateEffectiveSkill(raceEngine, sector, rider, weather) {
    return calculateSkill(raceEngine, sector, rider, raceEngine.modifiers.energy, rider.energy * 10)
        * calculateWindFactor(raceEngine, sector, weather, raceEngine.modifiers.energy)
        * rider.randomFactor;
  }

export function calculateSpeed(raceEngine, sector, rider, weather) { 
    let sectorSpeed = calculateSectorSpeed(sector, weather);
    let effectiveSkill = calculateEffectiveSkill(raceEngine, sector, rider, weather);    
    return sectorSpeed * Math.pow(effectiveSkill / raceEngine.baseSkill, sector.skillImpact.power);
}

export function calculateEnergyFactor(raceEngine, rider) { 
    return Math.pow((raceEngine.modifiers.energy.baseFloor + rider.energy * 10) / (raceEngine.modifiers.energy.baseFloor + raceEngine.modifiers.energy.base), raceEngine.modifiers.energy.power)
}

export function calculateRelativeWindforce(sector, weather) { 
    return Math.cos((sector.bearing - weather.windDirection) * Math.PI / 180) * weather.windforce
}

export function calculateWindFactor(raceEngine, sector, weather) {
    return 1 - calculateRelativeWindforce(sector, weather) * raceEngine.modifiers.wind.factor;
}

export function calculateRoadFactor(sector) {
    let maxSpeed = sector.baseSpeed;
    if (sector.direction === 'Winding')
        maxSpeed = Math.min(maxSpeed, 45);
    else if (sector.direction === 'Hairpins')
        maxSpeed = Math.min(maxSpeed, 30);
    return maxSpeed;
}

export function calculatePrecipitationFactor(sector, weather) {
    if (sector.incline < -5)
        return weather.precipitation === 'High' ? 0.8 : 1;
    else return 1;
}

export function calculateSectorSpeed(sector, weather) {
    return calculateRoadFactor(sector) * calculatePrecipitationFactor(sector, weather)
}

export const formBonus = (form) => (form - 85) / 4 - 2;

export const randomFactor = () => Math.abs(roundDigits(gaussianRandom(1, 0.01), 3));

export function calculateRiderSalary(rider) {
    console.log(rider);
    const flat = rider.flat;
    const climbing = rider.climbing;
    const downhill = rider.downhill;
    const regeneration = rider.regeneration;
    const sprint = rider.sprint;
    const cobbles = rider.cobbles;
    const timeTrial = rider.timeTrial;

    let salary = (
        Math.pow(
            (45 + (timeTrial - 45) * Math.pow(climbing, 2.96) / 550000 + Math.max(climbing, 40) + regeneration / 2),
            3.9
        ) * 200 +
        Math.pow(Math.max(flat, 40), 4.62) * 20 +
        Math.max(0, Math.pow(Math.max(0, (cobbles * 0.3 + flat * 0.7) - 70), 2.1)) * 60 * 29000 * 40 -
        Math.max(0, (70 - (cobbles * 0.3 + flat * 0.7)) * 100 * 29000 * 40) +
        Math.pow(Math.max(climbing, 40), 5.75) / 4 +
        Math.pow(Math.max(timeTrial, 40), 7.28) / 3436 +
        Math.pow(Math.max(sprint, 40), 6.21) / 35 +
        Math.max(0, (sprint - 45) * 100 * 29000 * 40) +
        Math.pow(regeneration, 2.3) * 300 +
        Math.pow(Math.max(downhill, 40), 3) * 8000
    ) / 29000;

    salary = (
        Math.pow(
            (45 + (timeTrial - 45) * Math.pow(climbing, 2.96) / 550000 + Math.max(climbing, 40) + regeneration / 2),
            3.9
        ) * 200 +
        Math.pow(Math.max(flat, 40), 4.62) * 20 +
        Math.max(0, Math.pow(Math.max(0, (cobbles * 0.3 + flat * 0.7) - 70), 2.1)) * 60 * 29000 * 40 -
        Math.max(0, (70 - (cobbles * 0.3 + flat * 0.7)) * 100 * 29000 * 40) +
        Math.pow(Math.max(climbing, 40), 5.75) / 4 +
        Math.pow(Math.max(timeTrial, 40), 7.28) / 3436 +
        Math.pow(Math.max(sprint, 40), 6.21) / 35 +
        Math.max(0, (sprint - 45) * 100 * 29000 * 40) +
        Math.pow(regeneration, 2.3) * 300 +
        Math.pow(Math.max(downhill, 40), 3) * 8000
    ) / 29000 -
    (((28 - 25) * 100000 - (Math.pow((28 - 21), 2.28))) / (3000000 / salary));

    return Math.max(Math.round(salary / 40), 25000);
}

export function calculateRiderValue(rider) {

    // ===== Konstante Faktoren =====
    const BASE_DIVISOR = 29000;
    const SPRINT_BONUS_FACTOR = 100 * 29000 * 40;
    const PAVE_FACTOR = 60 * 29000 * 40;
    const PAVE_MALUS_FACTOR = 100 * 29000 * 40;

    // ===== Skills (mit Mindestwert 40 falls erforderlich) =====
    const flach = Math.max(rider.flat, 40);
    const berg = Math.max(rider.climbing, 40);
    const abfahrt = Math.max(rider.downhill, 40);
    const sprint = Math.max(rider.sprint, 40);
    const zeit = Math.max(rider.timeTrial, 40);
    const regeneration = rider.regeneration;
    const paveReal = rider.cobbles;

    // ===== Abgeleitete Werte =====
    const age = Math.max(rider.age, 21);
    const pave = paveReal * 0.3 + flach * 0.7;

    // ===== Basiswert (Kernformel) =====
    const baseValue =
        Math.pow(
            45 +
            (zeit - 45) * Math.pow(berg, 2.96) / 550000 +
            berg +
            regeneration / 2,
            3.9
        ) * 200;
    console.log(baseValue);
    // ===== Einzelpreise =====
    const flachValue = Math.pow(flach, 4.62) * 20;
    const bergValue = Math.pow(berg, 5.75) / 4;
    const zeitValue = Math.pow(zeit, 7.28) / 3436;

    const sprintValue =
        Math.pow(sprint, 6.21) / 35 +
        (sprint - 45) * SPRINT_BONUS_FACTOR;

    const regenerationValue = Math.pow(regeneration, 2.3) * 300;
    const abfahrtValue = Math.pow(abfahrt, 3) * 8000;

    // ===== Pave-Bonus / Malus =====
    const paveExtra =
        pave > 70
            ? Math.pow(pave - 70, 2.1) * PAVE_FACTOR
            : - (70 - pave) * PAVE_MALUS_FACTOR;

    // ===== Gesamtpreis vor Alterskorrektur =====
    let preis = (
        baseValue +
        flachValue +
        bergValue +
        zeitValue +
        sprintValue +
        regenerationValue +
        abfahrtValue +
        paveExtra
    ) / BASE_DIVISOR;
    console.log(preis);
    // ===== Alterskorrektur =====
    const ageAdjustment =
        ((age - 25) * 100000 - Math.pow(age - 21, 2.28)) /
        (3000000 / preis);
    console.log(ageAdjustment);

    preis -= ageAdjustment;

    // ===== Saisonpunkte =====
    //preis += rider.pointsCurrentSeason * 150;

    return Math.round(preis);
}